<div class="card-item" (click)="onOpenItem(item.id)" title="Abrir tutorial"  [formGroup]="parentFormGroup"
  cdkDrag cdkDragLockAxis="y" [cdkDragData]="item" [ngClass]="{'disabled':disabled}"  [ngStyle]="item?.color ? { 'background-color': '#' + item.color } : null">
  <div class="custom-placeholder" *cdkDragPlaceholder></div>
  <span class="font-icon icon-drag" *ngIf="isOrdering"> 
    drag_indicator
  </span>
  <div class="check-div" *ngIf="!isOrdering && isAdmin"  [formGroupName]="index">
    <input type="checkbox"(click)="$event.stopPropagation();" (change)="onSelectItem()"  formControlName="selected" >
  </div>
  <div  class="file-image" *ngIf="type == 'material'">
    <img [src]="'assets/images/svgs/file-'+this.extension+'.svg'">
  </div>
  <div class="row g-0 w-100">
    <div class="card-data col-9">
      <h3 class="item-title">{{item.title}}</h3>
      <p class="description" *ngIf="item.description">{{item.description}}</p>
      <p class="description" *ngIf="item.duration">Tempo estimado: {{item.duration}}</p>
      <span class="date">Atualizado em {{item.ctr_dth_atu * 1000 | date:'dd/MM/yyyy'}}</span>
    </div>
    <div class="card-actions col-3" *ngIf="isAdmin">
      <button class="btn btn-blue btn-icon" type="button" (click)="onDelete($event)" title="Deletar item">
        <span class="font-icon">delete</span>
      </button>
      <button class="btn btn-blue btn-icon" type="button" *ngIf="disabled" (click)="onChangeShow($event)" title="Restaurar item">
        <span class="font-icon">visibility</span>
      </button>
      <button class="btn btn-blue btn-icon" type="button" *ngIf="!disabled" (click)="onChangeShow($event)" title="Ocultar item">
        <span class="font-icon">visibility_off</span>
      </button>
      <button class="btn btn-blue" type="button" (click)="onOpenModal(item.id)" title="Editar item">
        <span class="font-icon me-1">edit_square</span>Editar
      </button>
    </div>
  </div>
</div>